import React from 'react';

const Error404 = () => (
  <section className="bg-alt">
    <div className="container">
      <h2 className="text-center pb-2">Error 404</h2>
      <div className="row wow fadeInUp">
        <div className="col-md-8 col-md-ml-auto col-12">
          <div className="card">
            <div className="card-img-top" />
            <div className="card-body">
              <div className="text-secondary small">
                <p>Error 404: Page Not Found</p>
              </div>
              <h1 className="display-1">Oops.</h1>
              <h2>We can&apos;t seem to find the page you&apos;re looking for.</h2>
              <p className="lead mt-3">
                You may be able to find what you expected here if you,<br />
                <a href="/one">go back</a> or <a href="../../index.html">start at home</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  </section>
);
export default Error404;



// WEBPACK FOOTER //
// ./src/components/Error404.js